import React from 'react';
import { createPortal } from 'react-dom';
import { useTheme } from '@emotion/react';

const Portal = props => {
  var _globalThis$document;
  const {
    children,
    /* eslint-disable no-undef */
    /**
     * Update our eslint config to accommodate newer globals. Currently only
     * allow for ES6.
     */
    container = globalThis == null || (_globalThis$document = globalThis.document) == null ? void 0 : _globalThis$document.body,
    /**
     * Note: some components (like IPL `Modal`) may depend on the default
     * `wrapper`. Be cautious when changing.
     */
    wrapper = "ifl-portal"
  } = props;
  const theme = useTheme();
  const direction = theme.direction !== "ltr" ? theme.direction : null;
  const Content = wrapper ? /*#__PURE__*/React.createElement(wrapper, {
    dir: direction
  }, children) : children;
  return container ? /*#__PURE__*/createPortal(Content, container) : null;
};
Portal.displayName = "Portal";

export { Portal };
